
export default {
    name: 'SvgTrailerShell',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
